import { ApiRequestState, ApiSliceState } from "./types";

const getNewestRequestStatus = (state: ApiSliceState, endpoint: string): ApiRequestState | undefined => {
  const requests = Object.values(state[endpoint]);
  if (requests.length === 0) return undefined;
  const newestRequest = requests.reduce((previous, current) => {
    const previousStartedTimestamp = previous ? previous.startedTimeStamp : 0;
    if (current.startedTimeStamp > previousStartedTimestamp) {
      return current;
    }

    return previous;
  });

  return newestRequest;
}

const getRequestStatus = (state: ApiSliceState, endpoint: string, requestId?: string): ApiRequestState | undefined => {
  if (!requestId) return undefined;
  return state[endpoint][requestId];
}

const isRequestLoading = (state: ApiSliceState, endpoint: string, requestId?: string): boolean => {
  return getRequestStatus(state, endpoint, requestId)?.isLoading ?? false;
}

const requestError = (state: ApiSliceState, endpoint: string, requestId?: string) => {
  return getRequestStatus(state, endpoint, requestId)?.error ?? null;
}

const requestCompleted = (state: ApiSliceState, endpoint: string, requestId?: string) => {
  return getRequestStatus(state, endpoint, requestId)?.completed ?? false;
}

export default {
  getNewestRequestStatus,
  getRequestStatus,
  isRequestLoading,
  requestError,
  requestCompleted,
}
